import { Component } from '@angular/core';
import { GenericCrudComponent } from "../../../../shared/components/generic-crud/generic-crud.component";
import { RouterLink } from "@angular/router";
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { Paginator } from '../../../../models/Paginator';
import { License } from '../../../../models/License';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { Filter } from '../../../../models/GenericCRUD/Filter';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-license-configuration',
  standalone: true,
  imports: [
    GenericCrudComponent,
  ],
  templateUrl: './license-configuration.component.html',
  styleUrl: './license-configuration.component.css'
})
export class LicenseConfigurationComponent {
  tableColums: GenericTableColumn[] = [
    { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
    { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
    { name: 'Descripción', active: true, type: 'text', key: 'description', sort: false },
    { name: 'Requisitos', active: true, type: 'array', key: 'proof_requirements_objects.name', sort: false },
    { name: 'Fecha Creación', active: false, type: 'date', key: 'created_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
    { name: 'Fecha Modificación', active: false, type: 'date', key: 'updated_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
  ];

  formFields: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required', colspan: 2 },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required' },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    { 
      name: 'proof_requirements_objects', 
      type: 'select', 
      label: 'Requisitos', 
      colspan: 2, 
      singleSelection: false,
      optionsList: [
        { id: 'Teorico', name: 'Teórico' },
        { id: 'Cerrado', name: 'Cerrado' },
        { id: 'Abierto', name: 'Abierto' }
      ]
    },
  ];


  form: GenericForm = {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: this.formFields,
    name: 'permiso oficial',
    createButtonTitle: 'Nuevo permiso oficial',
    cols: 2,
    createApiSlug: '/config/license/store',
    formTitle: 'Crear permiso oficial',
    formButtonTitle: 'Crear permiso oficial',
    width: '4xl'
  }

  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      // actionSlug: '/config/office/update/{{id}}',
      form: {
        method: 'PUT',
        successTitle: 'Edición correcta',
        errorTitle: 'Error en la edición',
        fields: this.formFieldsEdit,
        name: 'license',
        createButtonTitle: '',
        cols: 2,
        originalFormTitle: 'Editar {{name}}',
        formTitle: '',
        formButtonTitle: 'Editar',
        width: '4xl',
        createApiSlug: '',
        originalUpdateApiSlug: '/config/license/update/{{id}}',
        updateApiSlug: '',
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: '<svg  xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.8"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" /><path d="M13.5 6.5l4 4" /><path d="M16 19h6" /></svg>',
      confirmation: false,

    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  class="w-4 text-primary"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.8"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
      confirmation: true,
      questionText: '¿Desea eliminar el permiso oficial?',
      deleteRowOnResponse: true,
      actionSlug: '/config/license/delete/{{id}}',
    }
  ]

  table: GenericTable<Paginator<License>> = {
    columns: this.tableColums,
    items: [],
    type: 'generic',
    loadItemsSlug: '/config/license/index',
    paginate: true,
    name: 'permisos oficiales',
    actions: this.tableActions
  };

  filters: Filter[] = [
    { type: 'search', key: 'name', operator: 'like', placeholder: 'Nombre' },
  ];

  genericCRUD: GenericCRUD<Paginator<License>> = {
    genericForm: this.form,
    genericTable: this.table,
    genericFilters: this.filters,
    useModalForm: true
  }
}
